import { Box, Heading, Link } from "@ogt/ui";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUnregisterFlow } from "../hooks/useUnregisterFlow";

export default function UnregisterTravelError() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const { unregisterData } = useUnregisterFlow();
  const navigate = useNavigate();

  useEffect(() => {
    if (!unregisterData) {
      navigate("/avboka-resa");
      return;
    }

    const { ReferenceId, EditId } = unregisterData;

    if (!ReferenceId || !EditId) {
      navigate("/avboka-resa-fel");
    }
  }, [unregisterData, navigate]);

  return (
    <div>
      <Box>
        <Heading headingRef={h2Ref} focusable>
          Något gick fel!
        </Heading>
        <p>
          Vi kunde tyvärr inte avanmäla gruppresan med referensnummer <br />
          <span className="sans-bold">
            ({unregisterData?.ReferenceId})
          </span>{" "}
          just nu på grund av ett fel på vår sida. Vi ber er att prova senare
          alternativt ringa till oss på telefonnummer <br />
          <Link underline="always" className="inline!" href="tel:+467715554444">
            0771 - 555 44 44
          </Link>
          så hjälper vi er att avanmäla.
        </p>
      </Box>
    </div>
  );
}
